export interface GetServiceListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetServiceListPagingAndFilterResponseData
}

export interface GetServiceListPagingAndFilterResponseData {
    items: GetServiceListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetServiceListPagingAndFilterResponseItem {
    serviceId: string
    companyId: string
    code: string
    name: string
    accountingCode: string
    isIncome: boolean
    incomePercentageId?: string
    isOutcome: boolean
    outcomePercentageId?: string
    transferDate?: string
    isCustomActive: boolean
    isAntrepoIn: boolean
    needQuantity: boolean
    isWithholding: boolean
    isAntrepoOut: boolean
    driverOutcomeId?: string
    incomePercentageName?: string
    outcomePercentageName?: string
    driverOutcomeName?: string
    serviceOutcomeTypes: GetServiceListPagingAndFilterResponseServiceOutcomeType[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetServiceListPagingAndFilterResponseServiceOutcomeType {
    label: string
    value: string
}

export const initialGetServiceListPagingAndFilterResponseData: GetServiceListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}